export const findEventClassroomForStudent = (eventClassrooms = [], studentClassroomIds = []) => {
  const eligibleIds = new Set((studentClassroomIds || []).map((id) => String(id)));
  return (eventClassrooms || []).find((classroom) => eligibleIds.has(String(classroom.classroomExternalId))) || null;
};
